<template>
  <li :class="[
    'sj-question-file-item',
    'sj-question-file__item',
    disabled?'disabled':'',
    selected?'selected':''
    ]">
    <div class="sj-question-file-item-poster">
      <slot>
        <i v-if="icon"
           :class="icon"></i>
        <img v-else
             :src="poster|ossThumbnail(75, 'FFFFFF')"
             :alt="poster">
      </slot>
    </div>
    <span class="el-upload-list__item-actions" v-if="showHoverIcons">
        <span class="el-upload-list__item-preview">
          <i class="el-icon-zoom-in"
             @click="$emit('view', this)"></i>
        </span>
        <span v-if="!disabled"
              class="el-upload-list__item-delete">
          <i class="el-icon-delete"
             @click="$emit('remove', this)"></i>
        </span>
      </span>
  </li>
</template>

<script>

export default {
  components: {},
  mixins: [],
  props: {
    poster: String,
    icon: String,
    disabled: Boolean,
    selected: Boolean,
    showHoverIcons: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
}
</script>
<style lang="scss">
$img-size: 75px;
.sj-question-file__item {
  position: relative;

  &.disabled {
    opacity: 0.75;
  }

  &:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  &.selected {
    margin: 9px !important;
    border: 1px solid #E6A23C;
  }

  .sj-question-file-item-poster {
    width: $img-size;
    height: $img-size;
    background-color: #f5f7fa;
    text-align: center;

    img {
      display: block;
      width: $img-size;
      height: $img-size;
    }

    i {
      color: #DCDFE6;
      font-size: 60px;
      line-height: 75px;
    }
  }

  .el-upload-list__item-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s;

    span {
      display: none;
      cursor: pointer;
    }

    span + span {
      margin-left: 15px
    }

    &:hover {
      opacity: 1;

      span {
        display: inline-block;
      }
    }

    &::after {
      display: inline-block;
      content: "";
      height: 100%;
      vertical-align: middle;
    }
  }

  .el-upload-list__item-delete {
    position: static;
    font-size: inherit;
    color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-file/src/SjQuestionFileItem.vue